import { addDays, subDays, addHours, startOfDay } from "date-fns";

const today = new Date();

export const mockAppointments = [
  {
    id: "1",
    title: "M&A Strategy Discussion",
    start: addHours(startOfDay(today), 9),
    end: addHours(startOfDay(today), 10),
    allDay: false,
    agenda: "admin-meetings",
    status: "confirmed",
    attendees: [
      {
        id: "1",
        name: "Admin User",
        email: "admin@example.com",
        role: "Admin",
      },
      {
        id: "2",
        name: "Advisor User",
        email: "advisor@example.com",
        role: "Advisor",
      },
    ],
    dealId: "deal-001",
    calendlyEventUri: "https://calendly.com/event/123456",
    description: "Strategic planning meeting for upcoming M&A transactions",
    location: "Conference Room A",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "2",
    title: "Client Due Diligence Review",
    start: addHours(startOfDay(addDays(today, 1)), 14),
    end: addHours(startOfDay(addDays(today, 1)), 15),
    allDay: false,
    agenda: "seller-meetings",
    status: "pending",
    attendees: [
      {
        id: "3",
        name: "Client User",
        email: "client@example.com",
        role: "Client",
      },
      {
        id: "2",
        name: "Advisor User",
        email: "advisor@example.com",
        role: "Advisor",
      },
    ],
    dealId: "deal-002",
    calendlyEventUri: "https://calendly.com/event/789012",
    description: "Review of due diligence documents and next steps",
    location: "Virtual - Zoom",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "3",
    title: "Advisor Training Session",
    start: addHours(startOfDay(addDays(today, 2)), 10),
    end: addHours(startOfDay(addDays(today, 2)), 12),
    allDay: false,
    agenda: "representative-meetings",
    status: "confirmed",
    attendees: [
      {
        id: "2",
        name: "Advisor User",
        email: "advisor@example.com",
        role: "Advisor",
      },
      {
        id: "1",
        name: "Admin User",
        email: "admin@example.com",
        role: "Admin",
      },
    ],
    dealId: null,
    calendlyEventUri: "https://calendly.com/event/345678",
    description: "Monthly training session for advisors",
    location: "Training Room B",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "4",
    title: "Deal Closing Meeting",
    start: addHours(startOfDay(addDays(today, 3)), 15),
    end: addHours(startOfDay(addDays(today, 3)), 17),
    allDay: false,
    agenda: "admin-meetings",
    status: "confirmed",
    attendees: [
      {
        id: "1",
        name: "Admin User",
        email: "admin@example.com",
        role: "Admin",
      },
      {
        id: "2",
        name: "Advisor User",
        email: "advisor@example.com",
        role: "Advisor",
      },
      {
        id: "3",
        name: "Client User",
        email: "client@example.com",
        role: "Client",
      },
    ],
    dealId: "deal-003",
    calendlyEventUri: "https://calendly.com/event/901234",
    description: "Final closing meeting for the acquisition deal",
    location: "Executive Conference Room",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "5",
    title: "Quarterly Review",
    start: addHours(startOfDay(subDays(today, 2)), 13),
    end: addHours(startOfDay(subDays(today, 2)), 14),
    allDay: false,
    agenda: "admin-meetings",
    status: "canceled",
    attendees: [
      {
        id: "1",
        name: "Admin User",
        email: "admin@example.com",
        role: "Admin",
      },
    ],
    dealId: null,
    calendlyEventUri: "https://calendly.com/event/567890",
    description: "Quarterly business review meeting",
    location: "Virtual - Teams",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const mockAgendas = [
  {
    id: "admin-meetings",
    name: "Admin Meetings",
    description: "Administrative and strategic meetings",
    color: "#0d6efd",
    ownerId: "1",
    visibility: "private",
    calendlyEventTypes: [
      {
        id: "event-type-1",
        name: "Strategy Session",
        uri: "https://calendly.com/admin/strategy-session",
        duration: 60,
      },
      {
        id: "event-type-2",
        name: "Deal Review",
        uri: "https://calendly.com/admin/deal-review",
        duration: 90,
      },
    ],
    settings: {
      allowBooking: true,
      requireApproval: false,
      bufferTime: 15,
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "representative-meetings",
    name: "Representative Meetings",
    description: "Advisor consultations and seller-meetings",
    color: "#198754",
    ownerId: "2",
    visibility: "public",
    calendlyEventTypes: [
      {
        id: "event-type-3",
        name: "Client Consultation",
        uri: "https://calendly.com/advisor/consultation",
        duration: 30,
      },
      {
        id: "event-type-4",
        name: "Follow-up Meeting",
        uri: "https://calendly.com/advisor/follow-up",
        duration: 45,
      },
    ],
    settings: {
      allowBooking: true,
      requireApproval: true,
      bufferTime: 10,
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "seller-meetings",
    name: "Seller Meetings",
    description: "Client-facing meetings and presentations",
    color: "#ffc107",
    ownerId: "1",
    visibility: "public",
    calendlyEventTypes: [
      {
        id: "event-type-5",
        name: "Initial Consultation",
        uri: "https://calendly.com/client/initial-consultation",
        duration: 60,
      },
      {
        id: "event-type-6",
        name: "Progress Update",
        uri: "https://calendly.com/client/progress-update",
        duration: 30,
      },
    ],
    settings: {
      allowBooking: true,
      requireApproval: false,
      bufferTime: 15,
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const mockDeals = [
  {
    id: "deal-001",
    name: "TechCorp Acquisition",
    status: "active",
    value: 50000000,
    description: "Acquisition of TechCorp by MegaCorp",
  },
  {
    id: "deal-002",
    name: "StartupX Merger",
    status: "pending",
    value: 25000000,
    description: "Merger between StartupX and InnovateCorp",
  },
  {
    id: "deal-003",
    name: "RetailChain Buyout",
    status: "closing",
    value: 75000000,
    description: "Private equity buyout of RetailChain",
  },
];

export const mockEventTypes = [
  {
    id: "event-type-1",
    name: "Strategy Session",
    uri: "https://calendly.com/admin/strategy-session",
    duration: 60,
    description: "Strategic planning and discussion session",
  },
  {
    id: "event-type-2",
    name: "Deal Review",
    uri: "https://calendly.com/admin/deal-review",
    duration: 90,
    description: "Comprehensive deal review and analysis",
  },
  {
    id: "event-type-3",
    name: "Client Consultation",
    uri: "https://calendly.com/advisor/consultation",
    duration: 30,
    description: "Initial client consultation meeting",
  },
  {
    id: "event-type-4",
    name: "Follow-up Meeting",
    uri: "https://calendly.com/advisor/follow-up",
    duration: 45,
    description: "Follow-up meeting with existing clients",
  },
  {
    id: "event-type-5",
    name: "Initial Consultation",
    uri: "https://calendly.com/client/initial-consultation",
    duration: 60,
    description: "Initial consultation for new clients",
  },
  {
    id: "event-type-6",
    name: "Progress Update",
    uri: "https://calendly.com/client/progress-update",
    duration: 30,
    description: "Progress update meeting",
  },
];
